import {
  GET_ORDERS_REQUEST,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAILURE,
  GET_ORDER_BY_ID_REQUEST,
  RESET_ACTIVE_ORDER,
  GET_ORDER_BY_ID_SUCCESS,
  GET_ORDER_BY_ID_FAILURE,
  ASSIGN_ORDER_REQUEST,
  ASSIGN_ORDER_SUCCESS,
  ASSIGN_ORDER_FAILURE,
  DENY_ORDER_REQUEST,
  DENY_ORDER_SUCCESS,
  DENY_ORDER_FAILURE,
  CREATE_MANUAL_ORDER_REQUEST,
  CREATE_MANUAL_ORDER_SUCCESS,
  CREATE_MANUAL_ORDER_FAILURE,
  EDIT_MANUAL_ORDER_REQUEST,
  EDIT_MANUAL_ORDER_SUCCESS,
  EDIT_MANUAL_ORDER_FAILURE,
  APPROVE_ORDER_REQUEST,
  APPROVE_ORDER_SUCCESS,
  APPROVE_ORDER_FAILURE,
  CREATE_COMPANY_ORDER_MESSAGE_REQUEST,
  CREATE_COMPANY_ORDER_MESSAGE_SUCCESS,
  CREATE_COMPANY_ORDER_MESSAGE_FAILURE,
  MARK_MESSAGE_READ_REQUEST,
  MARK_MESSAGE_READ_SUCCESS,
  MARK_MESSAGE_READ_FAILURE,
  APPRAISER_DENY_ORDER_REQUEST,
  APPRAISER_DENY_ORDER_SUCCESS,
  APPRAISER_DENY_ORDER_FAILURE,
  ACCEPT_ORDER_REQUEST,
  ACCEPT_ORDER_SUCCESS,
  ACCEPT_ORDER_FAILURE,
  UPLOAD_REPORT_REQUEST,
  UPLOAD_REPORT_SUCCESS,
  UPLOAD_REPORT_FAILURE,
  START_REPORT_SUBMISSION,
  END_REPORT_SUBMISSION,
  ORDER_OFFER_REQUEST,
  ORDER_OFFER_SUCCESS,
  ORDER_OFFER_FAILURE,
  FEE_ESCALATION_REQUEST,
  FEE_ESCALATION_SUCCESS,
  FEE_ESCALATION_FAILURE,
  SET_ORDER_INSPECTION_DATE_REQUEST,
  SET_ORDER_INSPECTION_DATE_SUCCESS,
  SET_ORDER_INSPECTION_DATE_FAILURE,
  ORDER_INSPECTION_COMPLETE_REQUEST,
  ORDER_INSPECTION_COMPLETE_SUCCESS,
  ORDER_INSPECTION_COMPLETE_FAILURE,
  APPRAISER_ACCEPT_ORDER_REQUEST,
  APPRAISER_ACCEPT_ORDER_SUCCESS,
  APPRAISER_ACCEPT_ORDER_FAILURE,
  CANCEL_ORDER_REQUEST,
  CANCEL_ORDER_SUCCESS,
  CANCEL_ORDER_FAILURE,
  GET_EVAULT_SUCCESS,
  GET_EVAULT_FAILURE,
  GET_EVAULT_REQUEST,
  CREATE_EVAULT_DOCUMENT_MODAL_SUCCESS,
  CREATE_EVAULT_DOCUMENT_MODAL_REQUEST,
  CREATE_EVAULT_DOCUMENT_MODAL_FAILURE,
  UPDATE_REVISION_REQUEST,
  UPDATE_REVISION_SUCCESS,
  UPDATE_REVISION_FAILURE,
  GET_CONVERSATION_BY_ORDER_ID_REQUEST,
  GET_CONVERSATION_BY_ORDER_ID_SUCCESS,
  GET_CONVERSATION_BY_ORDER_ID_FAILURE,
  GET_CONTACT_INFO_BY_ORDER_ID_REQUEST,
  GET_CONTACT_INFO_BY_ORDER_ID_SUCCESS,
  GET_CONTACT_INFO_BY_ORDER_ID_FAILURE,
  GET_OFFERS_BY_ORDER_ID_REQUEST,
  GET_OFFERS_BY_ORDER_ID_SUCCESS,
  GET_OFFERS_BY_ORDER_ID_FAILURE,
  GET_SUBMISSIONS_BY_ORDER_ID_REQUEST,
  GET_SUBMISSIONS_BY_ORDER_ID_SUCCESS,
  GET_SUBMISSIONS_BY_ORDER_ID_FAILURE,
  GET_REVISIONS_BY_ORDER_ID_REQUEST,
  GET_REVISIONS_BY_ORDER_ID_SUCCESS,
  GET_REVISIONS_BY_ORDER_ID_FAILURE,
} from '../constants/actionTypes'

const initialState = {
  orders: [],
  count: null,
  isFetching: false,
  isFetchingCompany: false,
  errorMessage: '',
  isCreating: false,
  isUpdatingChat: false,
  isAccepting: false,
  isUploading: false,
  isAppraiserAccepting: false,
  isRequestingCancel: false,
  isEditing: false,
  activeOrder: null,
  activeOrderError: '',
  isUpdatingOffer: false,
  isUpdatingRevision: false,
  submissionsInProgress: [],
  activeOrderConversation: null,
  isFetchingConversation: false,
}

export default function orderReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ORDERS_REQUEST:
      return {
        ...state,
        isFetching: action.isFetching,
      }
    case GET_ORDERS_SUCCESS:
      return {
        ...state,
        isFetching: action.isFetching,
        orders: action.orders,
        count: action.count,
      }
    case GET_ORDERS_FAILURE:
      return {
        ...state,
        isFetching: action.isFetching,
        errorMessage: action.message,
      }
    case GET_ORDER_BY_ID_REQUEST:
      return {
        ...state,
        isFetchingByID: action.isFetchingByID,
        activeOrderError: '',
        activeOrder: action.activeOrder,
      }
    case RESET_ACTIVE_ORDER:
      return {
        ...state,
        activeOrderError: '',
        activeOrder: null,
      }
    case GET_ORDER_BY_ID_SUCCESS:
      return {
        ...state,
        isFetchingByID: action.isFetchingByID,
        activeOrder: action.activeOrder,
        conversation: action.conversation,
        contactInfo: action.contactInfo,
        offers: action.offers,
        submissions: action.submissions,
        revisions: action.revisions,
      }
    case GET_ORDER_BY_ID_FAILURE:
      return {
        ...state,
        isFetchingByID: action.isFetchingByID,
        activeOrder: action.activeOrder,
        activeOrderError: action.message,
      }
    case ASSIGN_ORDER_REQUEST:
      return {
        ...state,
        isAssigning: action.isAssigning,
      }
    case ASSIGN_ORDER_SUCCESS:
      return {
        ...state,
        isAssigning: action.isAssigning,
        orders: action.orders,
        activeOrder: action.activeOrder,
      }
    case ASSIGN_ORDER_FAILURE:
      return {
        ...state,
        isAssigning: action.isAssigning,
        errorMessage: action.message,
      }
    case DENY_ORDER_REQUEST:
      return {
        ...state,
        isDenying: action.isDenying,
      }
    case DENY_ORDER_SUCCESS:
      return {
        ...state,
        isDenying: action.isDenying,
        orders: action.orders,
        activeOrder: action.activeOrder,
      }
    case DENY_ORDER_FAILURE:
      return {
        ...state,
        isDenying: action.isDenying,
        errorMessage: action.message,
      }
    case APPRAISER_DENY_ORDER_REQUEST:
      return {
        ...state,
        isDenying: action.isDenying,
      }
    case APPRAISER_DENY_ORDER_SUCCESS:
      return {
        ...state,
        isDenying: action.isDenying,
        orders: action.orders,
        activeOrder: action.activeOrder,
      }
    case APPRAISER_DENY_ORDER_FAILURE:
      return {
        ...state,
        isDenying: action.isDenying,
        errorMessage: action.message,
      }

    case CREATE_MANUAL_ORDER_REQUEST:
      return {
        ...state,
        isCreating: action.isCreating,
      }
    case CREATE_MANUAL_ORDER_SUCCESS:
      return {
        ...state,
        isCreating: action.isCreating,
        orders: action.orders,
      }
    case CREATE_MANUAL_ORDER_FAILURE:
      return {
        ...state,
        isCreating: action.isCreating,
        errorMessage: action.message,
      }
    case EDIT_MANUAL_ORDER_REQUEST:
      return {
        ...state,
        isEditing: action.isEditing,
      }
    case EDIT_MANUAL_ORDER_SUCCESS:
      return {
        ...state,
        isEditing: action.isEditing,
        orders: action.orders,
        activeOrder: action.activeOrder,
      }
    case EDIT_MANUAL_ORDER_FAILURE:
      return {
        ...state,
        isEditing: action.isEditing,
        errorMessage: action.message,
      }
    case APPROVE_ORDER_REQUEST:
      return {
        ...state,
        isApproving: action.isApproving,
      }
    case APPROVE_ORDER_SUCCESS:
      return {
        ...state,
        isApproving: action.isApproving,
        orders: action.orders,
        activeOrder: action.activeOrder,
      }
    case APPROVE_ORDER_FAILURE:
      return {
        ...state,
        isApproving: action.isApproving,
        errorMessage: action.message,
      }
    case CREATE_COMPANY_ORDER_MESSAGE_REQUEST:
      return {
        ...state,
        isUpdatingChat: action.isUpdatingChat,
      }
    case CREATE_COMPANY_ORDER_MESSAGE_SUCCESS:
      return {
        ...state,
        isUpdatingChat: action.isUpdatingChat,
        activeOrder: action.activeOrder,
        activeOrderConversation: action.activeOrderConversation,
      }
    case CREATE_COMPANY_ORDER_MESSAGE_FAILURE:
      return {
        ...state,
        isUpdatingChat: action.isUpdatingChat,
        errorMessage: action.message,
      }
    case MARK_MESSAGE_READ_REQUEST:
      return {
        ...state,
        isUpdatingChat: action.isUpdatingChat,
      }
    case MARK_MESSAGE_READ_SUCCESS:
      return {
        ...state,
        isUpdatingChat: action.isUpdatingChat,
        activeOrder: action.activeOrder,
      }
    case MARK_MESSAGE_READ_FAILURE:
      return {
        ...state,
        isUpdatingChat: action.isUpdatingChat,
        errorMessage: action.message,
      }
    case ACCEPT_ORDER_REQUEST:
      return {
        ...state,
        isAccepting: action.isAccepting,
      }
    case ACCEPT_ORDER_SUCCESS:
      return {
        ...state,
        isAccepting: action.isAccepting,
        orders: action.orders,
        activeOrder: action.activeOrder,
      }
    case ACCEPT_ORDER_FAILURE:
      return {
        ...state,
        isAccepting: action.isAccepting,
        errorMessage: action.message,
      }
    case UPLOAD_REPORT_REQUEST:
      return {
        ...state,
        isUploading: action.isUploading,
      }
    case UPLOAD_REPORT_SUCCESS:
      return {
        ...state,
        isUploading: action.isUploading,
        orders: action.orders,
        activeOrder: action.activeOrder,
        submissions: action.activeOrderSubmissions,
      }
    case UPLOAD_REPORT_FAILURE:
      return {
        ...state,
        isUploading: action.isUploading,
        errorMessage: action.message,
      }
    case START_REPORT_SUBMISSION:
      return {
        ...state,
        submissionsInProgress: [...state.submissionsInProgress, action.orderId],
      }
    case END_REPORT_SUBMISSION:
      return {
        ...state,
        submissionsInProgress: state.submissionsInProgress.filter(id => id !== action.orderId),
      }
    case ORDER_OFFER_REQUEST:
      return {
        ...state,
        isUpdatingOffer: action.isUpdatingOffer,
      }
    case ORDER_OFFER_SUCCESS:
      return {
        ...state,
        isUpdatingOffer: action.isUpdatingOffer,
        orders: action.orders,
        activeOrder: action.activeOrder,
        offers: action.offers,
      }
    case ORDER_OFFER_FAILURE:
      return {
        ...state,
        isUpdatingOffer: action.isUpdatingOffer,
        errorMessage: action.message,
      }
    case FEE_ESCALATION_REQUEST:
      return {
        ...state,
        isUpdatingFeeEscalation: action.isUpdatingFeeEscalation,
      }

    case FEE_ESCALATION_SUCCESS:
      return {
        ...state,
        isUpdatingFeeEscalation: action.isUpdatingFeeEscalation,
        orders: action.orders,
        activeOrder: action.activeOrder,
        offers: action.offers,
      }
    case FEE_ESCALATION_FAILURE:
      return {
        ...state,
        isUpdatingFeeEscalation: action.isUpdatingFeeEscalation,
        errorMessage: action.message,
      }
    case SET_ORDER_INSPECTION_DATE_REQUEST:
      return {
        ...state,
        isUpdatingInspectionDate: action.isUpdatingInspectionDate,
      }
    case SET_ORDER_INSPECTION_DATE_SUCCESS:
      return {
        ...state,
        isUpdatingInspectionDate: action.isUpdatingInspectionDate,
        orders: action.orders,
        activeOrder: action.activeOrder,
        errorMessage: null,
      }
    case SET_ORDER_INSPECTION_DATE_FAILURE:
      return {
        ...state,
        isUpdatingInspectionDate: action.isUpdatingInspectionDate,
        errorMessage: action.message,
      }
    case ORDER_INSPECTION_COMPLETE_REQUEST:
      return {
        ...state,
        isUpdatingInspectionComplete: action.isUpdatingInspectionComplete,
      }
    case ORDER_INSPECTION_COMPLETE_SUCCESS:
      return {
        ...state,
        isUpdatingInspectionComplete: action.isUpdatingInspectionComplete,
        orders: action.orders,
        activeOrder: action.activeOrder,
      }
    case ORDER_INSPECTION_COMPLETE_FAILURE:
      return {
        ...state,
        isUpdatingInspectionComplete: action.isUpdatingInspectionComplete,
        errorMessage: action.message,
      }
    case APPRAISER_ACCEPT_ORDER_REQUEST:
      return {
        ...state,
        isAppraiserAccepting: action.isAppraiserAccepting,
      }
    case APPRAISER_ACCEPT_ORDER_SUCCESS:
      return {
        ...state,
        isAppraiserAccepting: action.isAppraiserAccepting,
        orders: action.orders,
        activeOrder: action.activeOrder,
      }
    case APPRAISER_ACCEPT_ORDER_FAILURE:
      return {
        ...state,
        isAppraiserAccepting: action.isAppraiserAccepting,
        errorMessage: action.message,
      }
    case CANCEL_ORDER_REQUEST:
      return {
        ...state,
        isRequestingCancel: action.isRequestingCancel,
      }
    case CANCEL_ORDER_SUCCESS:
      return {
        ...state,
        isRequestingCancel: action.isRequestingCancel,
        orders: action.orders,
      }
    case CANCEL_ORDER_FAILURE:
      return {
        ...state,
        isRequestingCancel: action.isRequestingCancel,
        errorMessage: action.message,
      }
    case CREATE_EVAULT_DOCUMENT_MODAL_REQUEST:
      return {
        ...state,
        isUpdatingEvault: action.isUpdatingEvault,
      }
    case CREATE_EVAULT_DOCUMENT_MODAL_SUCCESS:
      return {
        ...state,
        isUpdatingEvault: action.isUpdatingEvault,
        activeOrder: action.activeOrder,
      }
    case CREATE_EVAULT_DOCUMENT_MODAL_FAILURE:
      return {
        ...state,
        isUpdatingEvault: action.isUpdatingEvault,
        errorMessage: action.message,
      }
    case GET_EVAULT_REQUEST:
      return {
        ...state,
        isUpdatingEvault: action.isUpdatingEvault,
      }
    case GET_EVAULT_SUCCESS:
      return {
        ...state,
        isUpdatingEvault: action.isUpdatingEvault,
        activeOrder: action.activeOrder,
      }
    case GET_EVAULT_FAILURE:
      return {
        ...state,
        isUpdatingEvault: action.isUpdatingEvault,
        errorMessage: action.message,
      }
    case UPDATE_REVISION_REQUEST:
      return {
        ...state,
        isUpdatingRevision: action.isUpdatingRevision,
      }
    case UPDATE_REVISION_SUCCESS:
      return {
        ...state,
        isUpdatingRevision: action.isUpdatingRevision,
        revisions: action.revisions,
      }
    case UPDATE_REVISION_FAILURE:
      return {
        ...state,
        isUpdatingRevision: action.isUpdatingRevision,
      }
    case GET_CONVERSATION_BY_ORDER_ID_REQUEST:
      return {
        ...state,
        isFetchingConversation: true,
      }
    case GET_CONVERSATION_BY_ORDER_ID_SUCCESS:
      return {
        ...state,
        isFetchingConversation: false,
        conversation: action.conversation,
      }
    case GET_CONVERSATION_BY_ORDER_ID_FAILURE:
      return {
        ...state,
        isFetchingConversation: false,
      }
    case GET_CONTACT_INFO_BY_ORDER_ID_REQUEST:
      return {
        ...state,
        isFetchingContactInfo: true,
      }
    case GET_CONTACT_INFO_BY_ORDER_ID_SUCCESS:
      return {
        ...state,
        isFetchingContactInfo: false,
        contactInfo: action.contactInfo,
      }
    case GET_CONTACT_INFO_BY_ORDER_ID_FAILURE:
      return {
        ...state,
        isFetchingContactInfo: false,
      }
    case GET_OFFERS_BY_ORDER_ID_REQUEST:
      return {
        ...state,
        isFetchingOffers: true,
      }
    case GET_OFFERS_BY_ORDER_ID_SUCCESS:
      return {
        ...state,
        isFetchingOffers: false,
        offers: action.offers,
      }
    case GET_OFFERS_BY_ORDER_ID_FAILURE:
      return {
        ...state,
        isFetchingOffers: false,
      }
    case GET_SUBMISSIONS_BY_ORDER_ID_REQUEST:
      return {
        ...state,
        isFetchingSubmissions: true,
      }
    case GET_SUBMISSIONS_BY_ORDER_ID_SUCCESS:
      return {
        ...state,
        isFetchingSubmissions: false,
        submissions: action.submissions,
      }
    case GET_SUBMISSIONS_BY_ORDER_ID_FAILURE:
      return {
        ...state,
        isFetchingSubmissions: false,
      }
    case GET_REVISIONS_BY_ORDER_ID_REQUEST:
      return {
        ...state,
        isFetchingRevisions: true,
      }
    case GET_REVISIONS_BY_ORDER_ID_SUCCESS:
      return {
        ...state,
        isFetchingRevisions: false,
        revisions: action.revisions,
      }
    case GET_REVISIONS_BY_ORDER_ID_FAILURE:
      return {
        ...state,
        isFetchingRevisions: false,
      }
    default:
      return state
  }
}
